
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/reset-and-continue-shopping-buttons/styles.css.ts.vanilla.css\",\"source\":\"Ll8xcnNvcDBjMCB7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBnYXA6IHZhcigtLV8xOHc3NmJ3Zyk7CiAgcGFkZGluZzogdmFyKC0tXzE4dzc2YndpKTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMTh3NzZidzI1KTsKfQ==\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/reset-and-continue-shopping-buttons/styles.css.ts.vanilla.css\",\"source\":\"Ll8xcnNvcDBjMCB7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBnYXA6IHZhcigtLV8xOHc3NmJ3Zyk7CiAgcGFkZGluZzogdmFyKC0tXzE4dzc2YndpKTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMTh3NzZidzI1KTsKfQ==\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
